document.addEventListener('DOMContentLoaded', function () {
	// Asset .js is NOT Liquid-processed, so read the real article data from the global set inline in theme.liquid (where Liquid runs). Falls back to nothing if absent.
	var _wwa = window.wwArticle || {};
	var article_title = _wwa.title || "";
	var articleID = _wwa.id || "";
	if (!articleID) { return; }
	fetch("https://api.comfortclick.co.uk/webhooks/v1/storefront/ww-articles/viewCount", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			blogTitle: article_title,
			articleID: articleID,

		}),
	})
	.then((response) => {
		if (!response.ok) {
			throw new Error("Network response was not ok");
		}
		return response.text().then(function (t) { try { return t ? JSON.parse(t) : {}; } catch (e) { return {}; } });
		})
		.then((data) => {
		})
		.catch((error) => {
			console.error("Error updating view count:", error);
		});
});